import type { SalesforceLocationResponse } from '@/types/salesforce';

/**
 * Fetches location data for a given ZIP code.
 * Returns null if no location is found (404).
 */
export async function fetchLocationByZipCode(
  zipCode: string
): Promise<SalesforceLocationResponse | null> {
  const response = await fetch(
    `/api/lookup-location?zipCode=${encodeURIComponent(zipCode)}`
  );

  // No location found - return null instead of throwing
  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to look up location');
  }

  return response.json();
}
